/**
 * Verlofsoort-waarden voor de ATDD-tests van epic 3 en 4 (verlof-correctie) —
 * ÉÉN plek, en sinds story 5.1 **afgeleid** uit de echte definitie in plaats
 * van geraden.
 *
 * ## Waarom dit bestand bestaat
 *
 * De tests van epic 3 en 4 hebben een boekende en een niet-boekende
 * verlofsoort nodig om te kunnen aantonen dat de herinneringskaart, de badge
 * *Niet bevestigd* en het bevestigings-endpoint de gedeelde lijst uit FR-22
 * volgen (AD-27, KE-9). Zonder deze module stond zo'n waarde letterlijk in
 * acht fixtures verspreid over vijf testbestanden.
 *
 * ## Wat er met story 5.1 veranderde
 *
 * De twee constanten stonden hier als gok, en beide waren fout:
 * `'calamiteiten_zorgverlof'` miste het woord `of`, en `'wettelijk'` is
 * helemaal geen `Verlofsoort`. Story 5.1 (AC-8) eist dat ze uit de énige
 * definitie worden afgeleid — `TEST_VERLOFSOORT_NIET_BOEKEND` gelijk aan
 * `NIET_BOEKENDE_SOORTEN[0]`, en `TEST_VERLOFSOORT_BOEKEND` een soort
 * waarvoor `soortBoektNooit` onwaar is. Wijzigt de tabel, dan volgt de hele
 * testverzameling vanzelf mee; zonder dat afleiden kunnen beide trajecten
 * apart groen staan op een andere spelling, en dan is groen niets waard.
 *
 * De reeks die dat afdwingt staat in
 * `packages/backend/src/__tests__/unit/verlofsoorten/story-5-1-gedeelde-begrippen.test.ts`.
 *
 * ## Grenzen
 *
 * - **Alleen tests importeren dit.** Productiecode leest de soort nooit hier,
 *   maar via `soortBoektNooit(rij.verlofsoort)` uit de gedeelde lijst (AD-27,
 *   KE-9). Een import van dit bestand buiten `__tests__/` is een fout; de
 *   negatieve test N6 in
 *   `packages/backend/src/__tests__/unit/verlof/story-3-1-herinneringsselectie.test.ts`
 *   bewaakt dat.
 * - **Dit is geen tweede definitie van "welke soort boekt nooit".** Er staat
 *   hier geen soortnaam meer; alles komt uit `VERLOFSOORTEN`.
 */
import { NIET_BOEKENDE_SOORTEN, VERLOFSOORTEN, soortBoektNooit, } from './leave.js';
/**
 * Een soort die WÉL naar de loonadministratie gaat: de gewone weg, waar de
 * herinneringskaart, de badge en het bevestigings-endpoint allemaal aan staan.
 *
 * Afgeleid: de eerste soort uit `VERLOFSOORTEN` waarvoor `soortBoektNooit`
 * onwaar is (story 5.1, AC-8).
 */
export const TEST_VERLOFSOORT_BOEKEND = Object.keys(VERLOFSOORTEN).find((soort) => !soortBoektNooit(soort));
/**
 * Een soort die NOOIT naar de loonadministratie gaat — vandaag calamiteiten-
 * en zorgverlof (verlofsoorten-PRD FR-9, FR-21, FR-22; besluit V16/V26).
 * Bij deze soort blijft de herinneringskaart weg (story 3.1, AC-17), blijft de
 * badge *Niet bevestigd* weg (story 3.2, AC-12) en weigert
 * `POST /:id/confirm-hours` met `LEAVE_BEVESTIGING_NIET_VAN_TOEPASSING`.
 * De correctietermijn loopt wél gewoon door (story 3.1, AC-18).
 *
 * Afgeleid: `NIET_BOEKENDE_SOORTEN[0]` (story 5.1, AC-8).
 */
export const TEST_VERLOFSOORT_NIET_BOEKEND = NIET_BOEKENDE_SOORTEN[0];
//# sourceMappingURL=verlofsoortTestwaarden.js.map